import { PERMISSION } from '@/constants/permission.constant';

const BodyTypesList = () => import('@/views/configuration/body-types/List.vue');
const BodyTypesAdd = () => import('@/views/configuration/body-types/Add.vue');
const BodyTypesEdit = () => import('@/views/configuration/body-types/Edit.vue');

export const bodyTypeRoute = [
  {
    path: '/configuration/body-types',
    name: 'BodyTypes',
    component: BodyTypesList,
    meta: { requiresAuth: false, permissions: [PERMISSION.BODY_TYPE_READ] },
  },

  {
    path: '/configuration/body-types/create',
    name: 'body-type-create',
    component: BodyTypesAdd,
    meta: { requiresAuth: false, permissions: [PERMISSION.BODY_TYPE_CREATE] },
  },
  {
    path: '/configuration/body-types/:id/edit',
    name: 'body-type-edit',
    component: BodyTypesEdit,
    meta: { requiresAuth: false, permissions: [PERMISSION.BODY_TYPE_UPDATE] },
  },
];
